export enum EButtonTypeV2 {
  REDEMPTION = 'redemption-in-progress',
  INVESTMENT = 'investment-in-progress',
  APPROVALS = 'approvals',
  REGISTER = 'register',
  IN_PORTABILITY = 'incoming-portability',
  OUT_PORTABILITY = 'outgoing-portability'
}

export interface IHomeButtonsV2 {
  title: string;
  buttons: IButtonDataV2[];
}

export interface IButtonDataV2 {
  icon: string;
  total: string;
  label: string;
  type: EButtonTypeV2;
}
